import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'modelosChecklist',
})
export class ModelosChecklistPipe implements PipeTransform {

  transform(
    items: any[],
    tipo: { auditoria: number } = null,
    extra: { id_local: number } = null,
    filtros: { id_local: any, id_departamento: any, id_partida: any } = null
  ) {

    if (items && items.length) {

      if (tipo) {
        items = items.filter((item) => {
          if (tipo.auditoria > 0) {
            return item.auditoria === 1;
          }

          return item.auditoria == 0;
        });
      }

      if (extra) {
        if (extra.id_local > 0) {
          items = items.filter((item) => {
            return item.id_local == extra.id_local;
          });
        }
      }

      if (filtros) {
        if (filtros.id_departamento > 0) {
          items = items.filter((item) => item.id_departamento == filtros.id_departamento);
        }

        if (filtros.id_partida > 0) {
          items = items.filter((item) => item.id_partida == filtros.id_partida);
        }

        if (filtros.id_local > 0) {
          items = items.filter((item) => item.id_local == filtros.id_local);
        }
      }

      return items;

    }

  }
}



// WEBPACK FOOTER //
// ./src/pipes/modelos-checklist/modelos-checklist.ts